import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function TopicSection() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-6 md:mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门影视专题</h2>
          <p className="text-sm text-foreground-500 mt-1">不同题材与风格的精选合集，发现更多你可能喜欢的作品</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {topics.map((topic) => (
            <Link
              key={topic.id}
              to={`/category/movie`}
              className="group relative rounded-lg overflow-hidden h-56 md:h-64 cursor-pointer block"
            >
              <img
                src={topic.cover}
                alt={topic.title}
                title={topic.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/30 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-1">{topic.title}</h3>
                <p className="text-xs md:text-sm text-background-100 line-clamp-2">{topic.description}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-xs text-accent-400 whitespace-nowrap">
                  查看专题 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}